// react toastify module
import { toast } from "react-toastify";

// create success method message
export const successMessage = (message) => {
  toast.success(message, {
    position: "top-right",
    closeOnClick: true,
  });
};

// create error method message

export const errorMessage = (message) => {
  toast.error(message, {
    position: "top-right",
    closeOnClick: true,
  });
};
